import { notification } from 'antd'
import React, { useEffect, type FC } from 'react'
import moment from 'moment'
import { useLocation } from 'react-router-dom'

const notificationData = {
  key: 'service_upgrade_notice_success_20250325',
  title: '服务升级完毕提醒',
  message: '3月23日-3月25日服务升级已完成，原始消息将陆续同步完毕。给您带来不便，敬请谅解。',
  startTime: null,
  endTime: '2025-03-29',
  pages: []
}

const OyNotification: FC = () => {
  const confirm = () => {
    localStorage.setItem('oy_notification_confirm', notificationData.key)
    return true
  }

  const location = useLocation()

  useEffect(() => {
    const isConfirm = localStorage.getItem('oy_notification_confirm')
    if (!isConfirm || isConfirm !== notificationData.key) {
      if (moment().isBefore(moment(notificationData.endTime))) {
        notification.warning({
          message: notificationData.title,
          description: notificationData.message,
          key: notificationData.key,
          onClose: confirm,
          duration: 0
        })
      }
    }

    return () => {
      notification.destroy()
    }
  }, [location])

  return <></>
}

export default OyNotification
